import { ChevronRight } from "lucide-react";
import type { AddressSuggestion } from "@/features/geo/shared/address-types";

interface Props {
  address: AddressSuggestion;
  onSelect: (address: AddressSuggestion) => void;
}

export function AddressDropdownItem({ address, onSelect }: Props) {
  return (
    <button
      type="button"
      onClick={() => onSelect(address)}
      className="group flex w-full cursor-pointer items-center justify-between border-b border-border px-4 py-3 text-left hover:bg-surface last:border-b-0"
    >
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium text-ink">
          {address.adresse.vejnavn} {address.adresse.husnr}
          {address.adresse.etage ? `, ${address.adresse.etage}.` : ""}
          {address.adresse.dør ? ` ${address.adresse.dør}` : ""}
        </p>
        <p className="truncate text-xs text-ink-subtle">
          {address.adresse.postnr} {address.adresse.postnrnavn}
        </p>
      </div>
      <ChevronRight className="ml-3 h-4 w-4 shrink-0 text-link" aria-hidden="true" />
    </button>
  );
}
